import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import authUser from '../Redux/reducer/authUser';
import memberReducer from '../Redux/reducer/memberReducer';
import dashboard from '../Redux/reducer/dashboard';
import visitorReducer from '../Redux/reducer/visitorReducer';
import seatBookingReducer from '../Redux/reducer/seatBookingReducer';
import roomReducer from './reducer/roomReducer';
import roomTraingReducer from './reducer/roomTraingReducer';
import complianceReducer from './reducer/complianceReducer';
import UI from '../Redux/reducer/ui';
import locationReducer from '../Redux/reducer/locationReducer';

import thunk from 'redux-thunk';
import seatReducer from './reducer/seatReducer';
import ticketReducer from './reducer/ticketReducer';
import invoice1Reducer from './reducer/invoice1Reducer';
import invoiceReducer from './reducer/invoiceReducer';
import enquiryFormReducer from './reducer/enquiryFormReducer';
import departmentReducer from './reducer/departmentReducer';
import rolemanagementReducer from './reducer/rolemanagementReducer';
import rosterReducer from './reducer/rosterReducer';
import shiftAssigningReducer from './reducer/shiftAssigningReducer';

import logger from 'redux-logger';

const initialState = {};
const middleware = [thunk];

const reducers = combineReducers({
  enquiry: enquiryFormReducer,
  activeUserList: memberReducer,
  ChartData: dashboard,
  authUser: authUser,
  visitorReducer: visitorReducer,
  UI: UI,
  seatBookingReducer: seatBookingReducer,
  seatReducer: seatReducer,
  roomReducer: roomReducer,
  ticketReducer: ticketReducer,
  roomTraingReducer: roomTraingReducer,
  complianceReducer: complianceReducer,
  invoiceReducer: invoiceReducer,
  departmentData: departmentReducer,
  rosterData: rosterReducer,
  rolemanagementReducer: rolemanagementReducer,
  invoice1Reducer: invoice1Reducer,
  locationReducer: locationReducer,
  shiftAssigning: shiftAssigningReducer,

});

const store = createStore(
  reducers,
  initialState,
  compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f,
    applyMiddleware(logger),
  ),
);

export default store;
